"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgHotPriceCircle = function SvgHotPriceCircle(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hot-price-circle_svg__a",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF860C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E5200E"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "url(#hot-price-circle_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M5.183 7.508c-1.166.855-1.529 2.41-.824 3.651.085.152.186.295.298.43l.039.045c.411.466 1.2.997 2.871 1.366l-.672-.808a1.46 1.46 0 0 1 .03-1.659l.028-.037c.285-.371 1.047-.793 1.273-1.204.25-.453.297-1.216.24-1.47 1.814 1.232 2.098 3.202 1.053 5.176 6.55-3.076 1.982-7.616 1.254-8.131.241.514.465 1.18-.025 1.604C9.92 3.421 7.695 3 7.695 3c.08.525.01 1.076-.16 1.621a4.933 4.933 0 0 1-1.8 2.484l-.552.403z"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgHotPriceCircle);
var _default = exports["default"] = Memo;